import React from "react";
import ReactPaginate from "react-paginate";
import { HiChevronRight, HiChevronLeft } from "react-icons/hi";

const Pagination = ({ itemsPerPage, total, onPageChange }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.floor(total / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="flex justify-center mt-10">
      <ReactPaginate
        previousLabel={
          <div className="p-2 rounded hover:bg-gray-300">
            <HiChevronLeft className="text-2xl" />
          </div>
        }
        nextLabel={
          <div className="p-2 rounded hover:bg-gray-300">
            <HiChevronRight className="text-2xl" />
          </div>
        }
        breakLabel={"..."}
        pageCount={pageNumbers.length}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={(data) => onPageChange(data.selected + 1)}
        containerClassName={"flex items-center justify-center"}
        pageClassName={""}
        pageLinkClassName={"px-4 py-2 rounded hover:bg-gray-300 group"}
        activeClassName={"font-bold"}
      />
    </div>
  );
};

export { Pagination as default };
